/**
 * TradePrizm wordmark: the owner's logo (apps/web/brand/tradeprizm-owner-transparent.svg, inlined
 * verbatim like components/Icon.tsx so it needs no extra request) and "Trade" + "Prizm" in the
 * logo's up green. The logo's white (#f4f7fb) strokes switch to the text colour on light themes
 * only (shell.css), where white would be invisible; nothing else changes.
 */
import { memo } from "react";

function BrandMarkImpl() {
  return (
    <svg className="brand-mark" viewBox="180 500 980 540" aria-hidden="true" focusable="false">
      <g fill="none" stroke="#f4f7fb" strokeWidth="3.5" strokeLinejoin="miter" strokeLinecap="square">
        <polyline points="250,812 292,776 334,812 376,776 418,812 470,790" />
        <polyline points="430,980 640,560 850,980 430,980" />
        <line x1="640" y1="560" x2="640" y2="980" />
        <line x1="640" y1="560" x2="790" y2="980" />
      </g>
      <g strokeLinejoin="miter" strokeLinecap="square">
        <line x1="900" y1="748" x2="900" y2="868" stroke="#f4f7fb" strokeWidth="2.5" />
        <rect x="886" y="784" width="28" height="62" fill="#d64545" stroke="#f4f7fb" strokeWidth="2.5" />
        <line x1="956" y1="812" x2="956" y2="868" stroke="#f4f7fb" strokeWidth="2.5" />
        <rect x="942" y="828" width="28" height="78" fill="#d64545" stroke="#f4f7fb" strokeWidth="2.5" />
        <line x1="1004" y1="900" x2="1004" y2="924" stroke="#f4f7fb" strokeWidth="2.5" />
        <line x1="994" y1="912" x2="1014" y2="912" stroke="#f4f7fb" strokeWidth="2.5" />
        <line x1="1048" y1="848" x2="1048" y2="908" stroke="#f4f7fb" strokeWidth="2.5" />
        <rect x="1036" y="864" width="24" height="32" fill="#21a35a" stroke="#f4f7fb" strokeWidth="2.5" />
        <line x1="1104" y1="620" x2="1104" y2="980" stroke="#f4f7fb" strokeWidth="2.5" />
        <rect x="1088" y="668" width="32" height="250" fill="#21a35a" stroke="#f4f7fb" strokeWidth="2.5" />
      </g>
    </svg>
  );
}

export const BrandMark = memo(BrandMarkImpl);

/** Logo + wordmark. `className` adds e.g. `login-brand`; the text reads "TradePrizm" (the logo is decorative). */
export function Brand({ className, as: Tag = "span" }: { className?: string; as?: "span" | "div" }) {
  return (
    <Tag className={className ? `brand ${className}` : "brand"}>
      <BrandMark />
      <span className="brand-word">
        Trade<span className="brand-word-accent">Prizm</span>
      </span>
    </Tag>
  );
}
